<template>
  <div class="w-100">
    <v-col
      cols="12"
      class="py-0 my-0 pb-3"
    >
      <v-checkbox
        :value="value"
        class="mt-0"
        :label="label"
        hide-details
        @change="updateValue"
      />
    </v-col>
    <template v-if="value">
      <v-row class="ml-8 pb-4">
        <slot />
      </v-row>
    </template>
  </div>
</template>

<script setup lang="ts">

const props = defineProps({
  label: { type: String, required: true },
  value: { type: Boolean, required: true },
});

const emit = defineEmits(['input']);
const updateValue = (val: boolean) => emit('input', val);

</script>
